import React from 'react';
import { number, string } from 'prop-types';

const IconClose = ({ size = 11, fill = '#4e0e28' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 10 11" fill="none">
      <path
        d="M10 1.03963L8.99286 0L5 4.12166L1.00714 0L0 1.03963L3.99286 5.16129L0 9.28295L1.00714 10.3226L5 6.20092L8.99286 10.3226L10 9.28295L6.00714 5.16129L10 1.03963Z"
        fill={fill}
      />
    </svg>
  );
};

IconClose.propTypes = {
  size: number,
  fill: string,
};

export default IconClose;
